<template>
  <div>
    <template v-for="(item, index) in listConfig">
      <div
        class="info-one-textarea"
        :key="`${item.prop}-${index}`"
        v-if="item.type == 'textarea'"
      >
        <div class="info-left">{{ item.label }}</div>
        <template>
          <template class="info-right" v-if="item.slot">
            <slot :name="item.prop" :index="index" :item="item"> </slot>
          </template>
          <div
            class="info-right"
            v-else-if="item.propInner && item.propInner != ''"
          >
            {{
              listData[item.prop]
                ? item.formatter
                  ? item.formatter(
                      item.label,
                      listData[item.prop][item.propInner]
                    )
                  : listData[item.prop][item.propInner]
                : "无"
            }}
          </div>
          <div class="info-right" v-else>
            {{
              item.formatter
                ? item.formatter(item.label, listData[item.prop])
                : listData[item.prop]
                ? listData[item.prop]
                : "无"
            }}
          </div>
        </template>
      </div>
      <div class="info-one" :key="`${item.prop}-${index}`" v-else>
        <div class="info-left">{{ item.label }}</div>
        <template>
          <template class="info-right" v-if="item.slot">
            <slot :name="item.prop" :index="index" :item="item"> </slot>
          </template>
          <div
            class="info-right"
            v-else-if="item.propInner && item.propInner != ''"
          >
            {{
              listData[item.prop]
                ? item.formatter
                  ? item.formatter(
                      item.label,
                      listData[item.prop][item.propInner]
                    )
                  : listData[item.prop][item.propInner]
                : "无"
            }}{{item.unit?item.unit:''}}
          </div>
          <div class="info-right" v-else>
            {{
              item.formatter
                ? item.formatter(item.label, listData[item.prop])
                : listData[item.prop]
                ? listData[item.prop]
                : "无"
            }}{{item.unit?item.unit:''}}
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "commonDetail",
  data() {
    return {};
  },
  props: {
    listData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    listConfig: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>

  .table-title {
    width: 100%;
    height: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 1rem;
    margin-top: 0.2rem;
    padding-left: 0.3rem;
    padding-right: 0.3rem;
    .title-left {
      font-size: 0.38rem;
      color: #666;
      font-weight: 600;
    }
    .title-right {
      font-size: 0.38rem;
      color: #ccc;
    }
  }
  .list-content {
    .info-one{
      background-color: #fff;
      border-top: 0.5px solid #f2f2f2;
      border-bottom: 0.5px solid #f2f2f2;
      padding-left: 0.3rem;
      padding-right: 0.3rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 1.2rem;
      padding-top: 0.15rem;
      padding-bottom: 0.15rem;
      .info-left {
        width: 35%;
        color: #999;
        font-size: 0.38rem;
      }
      .info-right {
        width: 67%;
        font-size: 0.38rem;
        text-align: right;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        // white-space: nowrap;
      }
    }
    .info-one-textarea {
      background-color: #fff;
      border-top: 0.5px solid #f2f2f2;
      border-bottom: 0.5px solid #f2f2f2;
      padding-left: 0.3rem;
      padding-right: 0.3rem;
      // display: flex;
      // justify-content: space-between;
      // align-items: center;
      // height: 1.3rem;
      .info-left {
        width: 100%;
        color: #999;
        font-size: 0.38rem;
        min-height: 1.3rem;
        line-height: 1.3rem;
      }
      .info-right {
        width: 100%;
        font-size: 0.38rem;
        // text-align: right;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        min-height: 0.3rem;
        padding-bottom: 0.3rem;
        // white-space: nowrap;
      }
    }
  }
  .item-one {
    background-color: #fff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);
    width: 100%;
    padding: 0.35rem 0.4rem;
    border-radius: 0.2rem;
    margin-bottom: 0.2rem;
    .item-index {
      font-size: 0.38rem;
      line-height: 0.7rem;
      color: #999;
      font-weight: 600;
    }
    .item-line {
      font-size: 0.38rem;
      line-height: 0.55rem;
      color: #999;
      span {
        margin-left: 0.3rem;
      }
    }
    .remark-content {
      font-size: 0.38rem;
      color: #333;
      line-height: 0.7rem;
    }
  }

</style>